/**
 * Recursively traverses and transforms "when" blocks using a provided update function.
 *
 * This function performs an in-place traversal of a nested `whenBlocks` tree,
 * applying `updateWhenBlock` to each block in a depth-first manner.
 * If a block has children (`blocks`), it will recurse into them first before updating the parent.
 *
 * @param {Array<Object>} whenBlocks - The array of blocks to traverse and transform.
 * @param {function(Object): Object} updateWhenBlock - A function that receives a block and returns an updated block.
 *
 * @example
 * traverseAndTransformWhenBlocks(rule.when, (block) => ({ ...block, extra: true }));
 */

export const traverseAndTransformWhenBlocks = (whenBlocks, updateWhenBlock) => {
    (function startRecursive(whenBlocks) {
        whenBlocks.forEach((block, index) => {
            if (Array.isArray(block?.blocks) && block.blocks.length > 0) {
                startRecursive(block.blocks);
            }

            whenBlocks[index] = updateWhenBlock(block);
        });
    })(whenBlocks);
};
